// apps/client/src/boot/errors.ts — uncaught errors → POST /api/client-errors (our own endpoint, spec §10.3; no third-party analytics)
import { api } from '../api/endpoints';
import { BUILD_ID } from './env';

const MAX_PER_MINUTE = 5;
export function installErrorReporting(win: Window = window): () => void {
  let sent: number[] = [];
  const report = (message: string, stack: string | null) => {
    const now = Date.now();
    sent = sent.filter((t) => now - t < 60_000);
    if (sent.length >= MAX_PER_MINUTE) return;
    sent.push(now);
    void api.clientError({ message: message.slice(0, 1000), stack: stack?.slice(0, 4000) ?? null, build: BUILD_ID, url: win.location.pathname, at: now }).catch(() => {});
  };
  const onError = (e: ErrorEvent) => report(e.message, e.error instanceof Error ? (e.error.stack ?? null) : null);
  const onRejection = (e: PromiseRejectionEvent) => {
    const reason: unknown = e.reason;
    report(reason instanceof Error ? reason.message : String(reason), reason instanceof Error ? (reason.stack ?? null) : null);
  };
  win.addEventListener('error', onError);
  win.addEventListener('unhandledrejection', onRejection);
  return () => { win.removeEventListener('error', onError); win.removeEventListener('unhandledrejection', onRejection); };
}
